import { IEvent } from '@swoft/core';

export class DomainUpdatedEvent implements IEvent {
  readonly type = 'DomainUpdated';
  readonly timestamp: Date;
  readonly aggregateId: string;
  readonly version: number;
  readonly correlationId?: string;

  constructor(
    public readonly domainId: string,
    public readonly domainName: string,
    public readonly previousState: any,
    public readonly newState: any,
    public readonly authSessionId: string,
    public readonly initiatedByPersonId: string,
    correlationId?: string,
    version: number = 1
  ) {
    this.aggregateId = domainId;
    this.version = version;
    this.timestamp = new Date();
    this.correlationId = correlationId;
  }
}